import { Alert, AlertIcon, AlertTitle, Flex } from '@chakra-ui/react';
import React from 'react';

const IncompleteNotification: React.FC = () => (
  <Alert status="info">
    <AlertIcon />
    <Flex direction={'column'}>
      <AlertTitle>Applicant has not submitted their application yet</AlertTitle>
    </Flex>
  </Alert>
);

export default IncompleteNotification;
